<template>
  <v-row no-gutters>
    <v-col cols="5.5">
      <data-input
        v-bind="{ ...inputBind, rules: getInputRules('min') }"
        v-model="computedMinzoom"
        @change="checkValues($event, 'min')"
      />
    </v-col>
    <v-col cols="1" class="text-center pt-2">
      -
    </v-col>
    <v-col cols="5.5">
      <data-input
        v-bind="{ ...inputBind, rules: getInputRules('max') }"
        v-model="computedMaxzoom"
        @change="checkValues($event, 'max')"
      />
    </v-col>
  </v-row>
</template>
<script>
import DataInput from '@/components/DataInput';
export default {
  name: 'StyleDialogZoomInput',
  components: { DataInput },
  props: {
    inputBind: {
      type: Object,
    },
    minzoom: {
      type: Number,
    },
    maxzoom: {
      type: Number,
    },
  },
  computed: {
    computedMinzoom: {
      get() {
        return this.minzoom || this.$_config.defaultMinZoom;
      },
      set(nV) {
        this.$emit('update:minzoom', nV || nV === 0 ? nV : null);
      },
    },
    computedMaxzoom: {
      get() {
        return this.maxzoom || this.$_config.defaultMaxZoom;
      },
      set(nV) {
        this.$emit('update:maxzoom', nV || nV === 0 ? nV : null);
      },
    },
  },
  methods: {
    getInputRules(type) {
      const rules = [...(this.inputBind?.rules || [])];
      if (type === 'min') {
        rules.unshift(
          v =>
            [null, undefined, ''].includes(v) ||
            [null, undefined, ''].includes(this.computedMaxzoom) ||
            v <= this.computedMaxzoom ||
            ''
        );
      } else if (type === 'max') {
        rules.unshift(
          v =>
            [null, undefined, ''].includes(v) ||
            [null, undefined, ''].includes(this.computedMinzoom) ||
            v >= this.computedMinzoom ||
            ''
        );
      }
      return rules;
    },
    checkValues(value, type) {
      if ([null, undefined, ''].includes(value)) {
        return;
      }
      if (type === 'min') {
        if ([null, undefined, ''].includes(this.computedMaxzoom)) {
          return;
        }
        if (value > this.computedMaxzoom) {
          this.computedMinzoom = this.computedMaxzoom;
          this.computedMaxzoom = value;
        }
      } else if (type === 'max') {
        if ([null, undefined, ''].includes(this.computedMinzoom)) {
          return;
        }
        if (value < this.computedMinzoom) {
          this.computedMaxzoom = this.computedMinzoom;
          this.computedMinzoom = value;
        }
      }
    },
  },
};
</script>
